export default class Breakpoints {
  /**
   *
   * @type {?string}
   */
  manual = null;

  /**
   *
   * @type {number}
   */
  xs;

  /**
   *
   * @type {number}
   */
  sm;

  /**
   *
   * @type {number}
   */
  md;

  /**
   *
   * @type {number}
   */
  lg;

  /**
   *
   * @type {number}
   */
  xl;

  /**
   *
   * @type {number}
   */
  rem = 16;

  constructor(bp) {
    this.xs = bp.xs;
    this.sm = bp.sm;
    this.md = bp.md;
    this.lg = bp.lg;
    this.xl = bp.xl;
  }

  /**
   *
   * @returns {number}
   */
  get() {
    return this[this.message()];
  }

  /**
   *
   * @returns {string}
   */
  message() {
    let breakpoint = null;
    if (this.manual) return this.manual;

    ["xl", "lg", "md", "sm", "xs"].forEach((bp) => {
      if (!breakpoint && this[bp]) breakpoint = bp;
    }, this);

    return breakpoint;
  }

  /**
   *
   * @param {string} bp
   * @returns {number}
   */
  toRem(bp) {
    return this[bp] / this.rem;
  }
}
